import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Briefcase,
  Boxes,
  Inbox,
  LogOut,
  ExternalLink,
} from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/services", label: "Services", icon: Boxes },
  { to: "/admin/portfolios", label: "Portfolio", icon: Briefcase },
  { to: "/admin/inquiries", label: "Inquiries", icon: Inbox },
];

export const AdminLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen flex bg-[#FAFAFA]" data-testid="admin-layout">
      <aside className="w-64 shrink-0 bg-[#0F172A] text-white flex flex-col">
        <div className="px-6 py-6 border-b border-white/10">
          <Logo size={36} inverse />
        </div>

        <nav className="flex-1 py-6 px-3 space-y-1">
          {items.map((it) => (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.end}
              data-testid={`admin-nav-${it.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#DC2626] text-white"
                    : "text-zinc-300 hover:bg-white/5"
                }`
              }
            >
              <it.icon size={18} />
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="px-3 pb-6 space-y-1">
          <a
            href="/"
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 px-3 py-2.5 text-sm text-zinc-300 hover:bg-white/5"
            data-testid="admin-view-site-link"
          >
            <ExternalLink size={18} />
            Lihat Website
          </a>
          <button
            onClick={handleLogout}
            data-testid="admin-logout-button"
            className="w-full flex items-center gap-3 px-3 py-2.5 text-sm text-zinc-300 hover:bg-white/5"
          >
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <div className="bg-white border-b border-[#E4E4E7] px-8 h-16 flex items-center justify-between">
          <div>
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-[#52525B]">
              Admin Panel
            </div>
            <div className="text-sm text-[#18181B]" data-testid="admin-current-user">
              {user?.email}
            </div>
          </div>
          <div className="text-xs font-mono-kt text-[#52525B]">
            CV. KOMUNIKA TEKNIK · v1.0
          </div>
        </div>
        <div className="p-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
